@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"
    >
    </ws-busy-indicator>
}

<ws-modal-wrapper [headerLabel]="((params.displayMode === DisplayMode.Add ? 'New ' : '') + 'G/L Account')"
                  (save)="save()"
                  (cancel)="cancel()"
                  [hideSave]="params.displayMode === DisplayMode.View"
                  [disableSave]="!form.valid">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3"
                     [ngClass]="{ 'has-error': form.controls.accountNumber.touched && form.controls.accountNumber.errors }">
                    <label for="name">G/L Account Number</label>
                    @if (params.displayMode === DisplayMode.View || params.foundInAccruals) {
                        <div>{{ form.controls.accountNumber.value }}</div>
                    }
                    @if (params.displayMode !== DisplayMode.View && !params.foundInAccruals) {
                        <input
                            type="text"
                            class="form-control"
                            formControlName="accountNumber"
                            autocomplete="off"/>
                    }
                    @if (form.controls.accountNumber.touched && form.controls.accountNumber.errors) {
                        <div
                            class="error-feedback">
                            @if (form.controls.accountNumber.errors.required) {
                                <div class="text-danger small">G/L Account Number is required.</div>
                            }
                            @if (form.controls.accountNumber.errors.maxlength) {
                                <div class="text-danger small">G/L Account Number max length is 100 characters.</div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3"
                     [ngClass]="{ 'has-error': form.controls.accountName.touched && form.controls.accountName.errors }">
                    <label for="name">G/L Account Name</label>
                    @if (params.displayMode === DisplayMode.View) {
                        <div>{{ form.controls.accountName.value }}</div>
                    }
                    @if (params.displayMode !== DisplayMode.View) {
                        <input
                            type="text"
                            class="form-control"
                            formControlName="accountName"
                            autocomplete="off"/>
                    }
                    @if (form.controls.accountName.touched && form.controls.accountName.errors) {
                        <div
                            class="error-feedback">
                            @if (form.controls.accountName.errors.required) {
                                <div class="text-danger small">G/L Account Name is required.</div>
                            }
                            @if (form.controls.accountName.errors.maxlength) {
                                <div class="text-danger small">G/L Account Name max length is 100 characters.</div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3"
                     [ngClass]="{ 'has-error': form.controls.description.touched && form.controls.description.errors }">
                    <label for="name">Description</label>
                    @if (params.displayMode === DisplayMode.View) {
                        <div>{{ form.controls.description.value }}</div>
                    }
                    @if (params.displayMode !== DisplayMode.View) {
                        <input
                            type="text"
                            class="form-control"
                            formControlName="description"
                            autocomplete="off"/>
                    }
                    @if (form.controls.description.touched && form.controls.description.errors) {
                        <div
                            class="error-feedback">
                            @if (form.controls.description.errors.maxlength) {
                                <div class="text-danger small">G/L Account Description max length is 500 characters.
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3">
                    <label for="name">Account Type</label>
                    @if (params.displayMode === DisplayMode.View || params.foundInAccruals) {
                        <div>{{ currAccountType?.name }}</div>
                    }
                    @if (params.displayMode !== DisplayMode.View && !params.foundInAccruals) {
                        <div>
                            <select id="accountType"
                                    name="accountType"
                                    class="form-select form-select-sm"
                                    formControlName="selectedAccountType"
                                    (change)="accountTypeChanged($event)">
                                @for (at of accountTypes; track at) {
                                    <option [ngValue]="at">{{ at.name }}</option>
                                }
                            </select>
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="row" [hidden]="!accrualsFeatureEnabled || !currAccountType.validForAccrual">
            <div class="col-lg-12">
                <div class="mb-3">
                    <label for="applicToAccruals" class="ws-font-weight-normal">
                        <input type="checkbox"
                               id="applicToAccruals"
                               formControlName="applicableToAccruals"
                               (change)="switchApplicableToAccruals($event)">
                        Applicable to accruals
                    </label>
                    @if ((params.displayMode === DisplayMode.View && form.controls.selectedAccountAccrualType.value) || params.foundInAccruals) {
                        <div style="width: auto; display: inline-block; margin-left: 15px"
                             [hidden]="!form.controls.applicableToAccruals.value">{{ form.controls.selectedAccountAccrualType.value?.name }}
                        </div>
                    }
                    @if (params.displayMode !== DisplayMode.View && !params.foundInAccruals) {
                        <div style="width: auto; display: inline-block; margin-left: 15px;"
                             [hidden]="!form.controls.applicableToAccruals.value">
                            <select id="accountAccrualType"
                                    name="accountAccrualType"
                                    class="form-select form-select-sm"
                                    formControlName="selectedAccountAccrualType"
                                    (change)="accountAccrualTypeChanged()">
                                @for (aat of currAccountAccrualTypes; track aat) {
                                    <option [ngValue]="aat">{{ aat.name }}</option>
                                }
                            </select>
                        </div>
                    }
                </div>
                <div class="mb-3"
                     [hidden]="!form.controls.applicableToAccruals.value || form.controls.selectedAccountAccrualType.value?.glAccountAccrualTypeId != PropertyTaxPayableType">
                    <label for="includesPrepaid" class="ws-font-weight-normal">
                        <input type="checkbox" id="includesPrepaid" formControlName="payableIncludesPrepaid">
                        Includes Prepaid
                    </label>
                </div>
            </div>
        </div>

        <div class="card panel-flat-color secondary-panel"
             [hidden]="!accrualsFeatureEnabled || !form.controls.applicableToAccruals.value">
            <div class="panel-flat-header" style="margin-bottom: 0;">
                <div class="header-icon">
                    <i class="fa fa-filter"></i>
                </div>
                <h3>Accrual Scope</h3>
            </div>
            <div class="panel-flat-body">
                <div class="col-lg-12">
                    <div class="mb-3">
                        <div style="display: inline-block; vertical-align: top;">
                            <label>Property Types:</label>
                        </div>
                        <div style="display: inline-block; margin-left: 10px;">
                            @for (propTypeControl of fPropTypes.controls; track propTypeControl; let ptIndex = $index) {
                                <div
                                    formArrayName="forPropertyTypes"
                                    style="display: block;">
                                    <label>
                                        <input type="checkbox" [formControl]="$any(propTypeControl)">
                                        {{ propertyTypes[ptIndex].name }}
                                    </label>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="mb-3">
                        <div style="display: inline-block; vertical-align: top;">
                            <label>Payment Types:</label>
                        </div>
                        <div style="display: inline-block; margin-left: 10px;">
                            @for (pmtTypeControl of fPmtTypes.controls; track pmtTypeControl; let pmtIndex = $index) {
                                <div
                                    formArrayName="forPaymentTypes"
                                    style="display: block;">
                                    <label>
                                        <input type="checkbox" [formControl]="$any(pmtTypeControl)">
                                        {{ paymentTypes[pmtIndex].name }}
                                    </label>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                @if (isTopLevelCompany) {
                    <div class="col-lg-12">
                        <div class="mb-3">
                            <div style="display: inline-block; vertical-align: top; margin-top: 0;">
                                <label>Companies:</label>
                            </div>
                            <div style="display: inline-block; vertical-align: top; margin-left: 20px;">
                                <div class="row radio" style="margin-top: 0;">
                                    <label>
                                        <input type="radio"
                                               name="forAllCompanies"
                                               [value]="true"
                                               formControlName="forAllCompanies">
                                        Top level and all subsidiaries
                                    </label>
                                </div>
                                <div class="row radio" style="margin-top: 10px;">
                                    <label>
                                        <input type="radio"
                                               name="forAllCompanies"
                                               [value]="false"
                                               formControlName="forAllCompanies">
                                        Specific list of companies
                                    </label>
                                </div>
                            </div>
                            @if (!form.controls.forAllCompanies.value && accrualScopeCompanies.length) {
                                <div
                                    style="display: inline-block; vertical-align: top; margin-left: 20px;">
                                    <select multiple class="filter-select" formControlName="forCompanies">
                                        @for (company of accrualScopeCompanies; track company) {
                                            <option [ngValue]="company.id">
                                                {{ company.name }}
                                            </option>
                                        }
                                    </select>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
        @if (showAssetClassification) {
            <div class="row"
                 [hidden]="accrualsFeatureEnabled && form.controls.applicableToAccruals.value"
            >
                <div class="col-lg-12">
                    <div class="mb-3">
                        <label for="name">Asset Class</label>
                        @if (params.displayMode === DisplayMode.View || params.foundInAccruals) {
                            <div>{{ form.controls.assetClassificationName.value }}</div>
                        }
                        @if (params.displayMode !== DisplayMode.View && !params.foundInAccruals) {
                            <div>
                                <asset-class-selector [isRequiredField]="false"
                                                      formControlName="assetClassificationId"
                                                      (assetClassificationChange)="onAssetClassificationChanged($event)">
                                </asset-class-selector>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        @if (showIncomeStatementCategory) {
            <div class="row">
                <div class="col-lg-12">
                    <div class="mb-3">
                        <label for="name">Income Statement Category</label>
                        @if (params.displayMode === DisplayMode.View || params.foundInAccruals) {
                            <div>{{ form.controls.incomeStatementCategoryName.value }}</div>
                        }
                        @if (params.displayMode !== DisplayMode.View && !params.foundInAccruals) {
                            <div>
                                <income-statement-category-selector [isRequiredField]="false"
                                                                    [glAccountTypeId]="currAccountType.glAccountTypeId"
                                                                    formControlName="incomeStatementCategoryId"
                                                                    (incomeStatementCategoryChange)="onIncomeStatementCategoryChanged($event)">
                                </income-statement-category-selector>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        @if (showIncomeStatementCategory && glAccount.glAccountId) {
            <div class="row">
                <label>
                    <input type="checkbox" style="margin-right: 5px;"
                           formControlName="isValidated">
                    Is Validated
                </label>
            </div>
        }
    </form>
</ws-modal-wrapper>
